import React from 'react';
import { ClipboardList } from 'lucide-react';

const OrderManagement: React.FC = () => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <ClipboardList className="w-6 h-6 text-blue-600" />
        <h1 className="text-2xl font-semibold text-gray-800">Order Management</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Order management interface will be implemented here.</p>
      </div>
    </div>
  );
};

export default OrderManagement;